import axios from "axios";

const getHeaders = () => ({
  Authorization: `Bearer ${window.localStorage.getItem("token")}`,
});

export const apiInstance = () => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      ...getHeaders(),
      "Content-Type": "application/json",
      //'Content-Type': 'multipart/form-data',
      "Access-Control-Allow-Origin": process.env.REACT_APP_UI_URL,
      //'Access-Control-Allow-Origin': '*',
      //'Access-Control-Allow-Credentials': 'true',
      //'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS',
      //'Access-Control-Allow-Headers': 'X-Requested-With'
    },
    // auth: {
    //   username: process.env.REACT_APP_SECRET_NAME,
    //   password: process.env.REACT_APP_SECRET_KEY
    // }
  });
};

export const apiInstanceUserToken = () => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      ...getHeaders(),
      "Content-Type": "application/json",
      Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": process.env.REACT_APP_UI_URL,
    },
  });
};

export const apiFormInstance = () => {
  axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      ...getHeaders(),
      "Content-Type": "multipart/form-data",
      //'Content-Type': 'multipart/form-data',
      "Access-Control-Allow-Origin": process.env.REACT_APP_UI_URL,
      //'Access-Control-Allow-Origin': '*',
      //'Access-Control-Allow-Credentials': 'true',
      //'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS',
      //'Access-Control-Allow-Headers': 'X-Requested-With'
    },
    // auth: {
    //   username: process.env.REACT_APP_SECRET_NAME,
    //   password: process.env.REACT_APP_SECRET_KEY
    // }
  });
};

export const apiInstanceNoToken = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    //'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': process.env.REACT_APP_UI_URL,
    //'Access-Control-Allow-Origin': '*',
    //'Access-Control-Allow-Credentials': 'true',
    //'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS',
    //'Access-Control-Allow-Headers': 'X-Requested-With'
  },
  auth: {
    username: process.env.REACT_APP_SECRET_NAME,
    password: process.env.REACT_APP_SECRET_KEY
  }
});


// WEBPACK FOOTER //
// ./src/helpers/http.js